import io from 'socket.io-client'
import { isEmpty } from '../../../utils'
import { DATA_TYPE } from './const/data-type'
import { EVENT_TYPE } from './const/event-type'
import { MESSAGE_TYPE } from './const/message-type'
import { message } from './message'

export default class Communication {
  _socket

  _message

  _wsTimerOut = -1

  get socket() {
    return this._socket
  }

  get connected() {
    return this.socket.connected
  }

  get disconnected() {
    return this.socket.disconnected
  }

  get message() {
    return this._message
  }

  constructor(server, env) {
    this._socket = io(server, {
      autoConnect: false,
      path: '/socket.io',
      transports: ['websocket'],
      secure: env === 'uat' || env === 'prod'
    })
    this.load = this.load.bind(this)
    this.onChat = this.onChat.bind(this)
    this.onHistory = this.onHistory.bind(this)
    this.unload = this.unload.bind(this)
    this._message = message
  }

  /**
   *
   */
  init(data) {
    this.onConnect()
    this.onDisconnect()
    this._message.init(data)
  }

  updateUser(user) {
    this._message.setUserInfo(user)
  }

  destroy() {
    this.socket.off('connect', this.load)
    this.socket.off('disconnect', this.unload)
  }

  start() {
    if (this.disconnected) {
      return this.socket.open()
    }
  }

  end() {
    if (this.connected) {
      return this.socket.close()
    }
  }

  onConnect() {
    this.socket.on('connect', this.load)
    this.setCheckTimer()
  }

  onDisconnect() {
    this.socket.on('disconnect', this.unload)
  }

  setCheckTimer() {
    // 5分钟没有发送相关消息，则断开连接
    clearTimeout(this._wsTimerOut)
    this._wsTimerOut = setTimeout(() => {
      this.end()
    }, 5000 * 60)
  }

  load() {
    this.socket.on(EVENT_TYPE.CHAT, this.onChat)
    this.socket.on(EVENT_TYPE.HISTORY, this.onHistory)
  }

  unload() {
    this.socket.off(EVENT_TYPE.CHAT, this.onChat)
    this.socket.off(EVENT_TYPE.HISTORY, this.onHistory)
  }

  onChat(chat) {
    this.setCheckTimer()
    this.message.handleChat(chat)
  }

  onHistory(data) {
    this.setCheckTimer()
    const isJsonString = str => {
      try {
        const obj = JSON.parse(str)
        return {
          status: true,
          obj
        }
      } catch (e) {
        return {
          status: false
        }
      }
    }
    let dispatchStatus = 'normal'
    if (!isEmpty(data)) {
      if (!isEmpty(this.message._messageList)) {
        // 点击历史消息时，已经进行了部分聊天，只需要追加部分消息在列表
        data = data.slice(0, data.length - this.message._messageList.length).reverse()
        dispatchStatus = 'addHistory'
      }
      data.forEach(chat => {
        try {
          const { status, obj = null } = isJsonString(chat.data)
          chat.data = status ? obj : chat.data
          this.message.dispatchMessage(chat, dispatchStatus)
        } catch (e) {}
      })
    }
    !!this._historyCallBack && this._historyCallBack()
  }

  emit(type, data) {
    clearTimeout(this._wsTimerOut)
    this.start()
    this.socket.emit(type, data)
  }

  /**
   * 文档搜索
   * @param text {String}
   */
  search(text) {
    this.emit(EVENT_TYPE.CHAT, this.message.sendWithMeta(MESSAGE_TYPE.SEARCH, DATA_TYPE.TEXT, text))
  }

  /**
   * 开始反馈(点击"系统反馈")
   */
  startFeedback() {
    this.emit(
      EVENT_TYPE.CHAT,
      this.message.sendWithMeta(MESSAGE_TYPE.FEEDBACK_REQUEST, DATA_TYPE.TEXT)
    )
  }

  /**
   * 选择反馈类型
   * @param type {object} 反馈数据
   */
  selectType(typeData) {
    this.emit(EVENT_TYPE.CHAT, this.message.selectType(typeData))
  }

  /**
   * 发送反馈内容
   * @param data {text: String, images: String[]}
   * @param feedbackStatus {Boolean}
   */
  sendFeedback(data, status) {
    this.emit(EVENT_TYPE.CHAT, this.message.sendFeedback(data, status))
  }

  getHistory(historyCallBack) {
    this._historyCallBack = historyCallBack
    this.emit(EVENT_TYPE.HISTORY, this.message.getHistory())
  }
}
